import React from 'react';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { Button, IconButton, FormControl, Paper, Slide, Typography,
  withStyles, InputLabel, Select, MenuItem, TextField, Checkbox, FormControlLabel } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { parse, format, subMonths, addDays, isBefore, differenceInCalendarDays } from 'date-fns';
import AspectRatio from '@material-ui/icons/AspectRatio';
import VariantSnackbar from '../share/VariantSnackbar';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import classnames from 'classnames';
import RelatorioBeneficiariosService from '../../services/RelatorioBeneficiariosService';
import FullScreenRelatorioBeneficiarios from './FullScreenRelatorioBeneficiarios';

const styles = theme => ({
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
  },
  buttonMarcar: {
    marginLeft: theme.spacing.unit,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  selectTipoArquivo: {
    margin: theme.spacing.unit,
    width: 400,
  },
  selectTipoData: {
    margin: theme.spacing.unit,
    width: 250,
  },
  textField: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    width: 232,
  },
  textFieldIdade: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    width: 60,
  },
  iconButton: {
    marginBottom: theme.spacing.unit,
  },
  invisible: {
    display: 'none',
  },
  formControl: {
  },
  typographyTituloPaper: {
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    color: theme.palette.text.secondary,
    fontSize: 13
  },
  typographyObrigatorios: {
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 2,
    fontSize: 13
  },
  paperCamposOpcionais: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  paperCamposObrigatorios: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  checkBox: {
    marginLeft: theme.spacing.unit * 3,
  },
});

class RelatorioBeneficiarios extends React.Component {
  relatorioBeneficiariosService = new RelatorioBeneficiariosService();
  state = {
    beneficiarios: [],
    beneficiariosJson: [],
    fetching: false,
    filtro: {},
    codTipoConsultaSelected: 1,
    from: format(subMonths(new Date(), 12), 'YYYY-MM-DD'),
    to: format(new Date(), 'YYYY-MM-DD'),
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    sucesso: true,
    errorMessageDataInicial: '',
    errorMessageDataFinal: '',
    errorMessageIdade: '',
    checkTodos: true,
    checkEndereco: true,
    checkTelefone: true,
    checkEmail: true,
    checkMae: true,
    checkSituacao: true,
    checkTutelado: true,
    checkDepEconomico: true,
    checkInvalidez: true,
    checkPensionista: true,
    checkDependentes: true,
    idade: null,
    fullScreenPrintOpen: false,
    tituloConsulta: '',
}

handleClickVisualizar = async () => {
  const filtro = {
    codTipoConsulta: this.state.codTipoConsultaSelected,
    idade: this.state.idade,
    dtaInicio: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
    dtaFim: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
    indEndereco: 0,
    indTelefone: 0,
    indEmail: 0,
    indMae: 0,
    indSituacao: 0,
    indTutelado: 0,
    indDepEconomico: 0,
    indInvalidez: 0,
    indPensionista: this.state.checkPensionista === true ? 1 : 0,
    indDependentes: this.state.checkDependentes === true ? 1 : 0,
  };
  let tituloConsulta = '';
  if (this.state.codTipoConsultaSelected === 1) {
    tituloConsulta = 'Consulta Geral - Beneficiários com data de adesão de ' + format(new Date(filtro.dtaInicio), 'DD/MM/YYYY') + ' a ' + format(new Date(filtro.dtaFim), 'DD/MM/YYYY')
  }
  if (this.state.codTipoConsultaSelected === 2) {
    tituloConsulta = 'Beneficiários que estão no Plano - Beneficiários com data de adesão de ' + format(new Date(filtro.dtaInicio), 'DD/MM/YYYY') + ' a ' + format(new Date(filtro.dtaFim), 'DD/MM/YYYY')
  }
  if (this.state.codTipoConsultaSelected === 3) {
    tituloConsulta = 'Beneficiários que saíram do Plano - Beneficiários com data de saída de ' + format(new Date(filtro.dtaInicio), 'DD/MM/YYYY') + ' a ' + format(new Date(filtro.dtaFim), 'DD/MM/YYYY')
  }
  if (this.state.codTipoConsultaSelected === 4) {
    tituloConsulta = 'Beneficiários que completaram aniversário - ' + filtro.idade + ' anos com aniversário entre ' + format(new Date(filtro.dtaInicio), 'DD/MM/YYYY') + ' e ' + format(new Date(filtro.dtaFim), 'DD/MM/YYYY')
  }
  this.setState({fullScreenPrintOpen: true, filtro: filtro, tituloConsulta: tituloConsulta});
}

  handleClickBuscar = async () => {
    this.setState({fetching: true});
    const filtro = {
      codTipoConsulta: this.state.codTipoConsultaSelected,
      idade: this.state.idade,
      dtaInicio: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dtaFim: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
      indEndereco: this.state.checkEndereco === true ? 1 : 0,
      indTelefone: this.state.checkTelefone === true ? 1 : 0,
      indEmail: this.state.checkEmail === true ? 1 : 0,
      indMae: this.state.checkMae === true ? 1 : 0,
      indSituacao: this.state.checkSituacao === true ? 1 : 0,
      indTutelado: this.state.checkTutelado === true ? 1 : 0,
      indDepEconomico: this.state.checkDepEconomico === true ? 1 : 0,
      indInvalidez: this.state.checkInvalidez === true ? 1 : 0,
      indPensionista: this.state.checkPensionista === true ? 1 : 0,
      indDependentes: this.state.checkDependentes === true ? 1 : 0,
    };
    await this.consultarBeneficiarios(filtro);
    this.setState({fetching: false});
  }
  consultarBeneficiarios = async (filtro) => {
    let nomeArquivo = '';
    // Consulta Geral
    if (this.state.codTipoConsultaSelected === 1) {
      nomeArquivo = 'beneficiarios_consulta_geral_de_' + 
      format(new Date(filtro.dtaInicio), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dtaFim), 'DD_MM_YYYY') + '.csv';
    }
    // Beneficiários que estão no Plano
    if (this.state.codTipoConsultaSelected === 2) {
      nomeArquivo = 'beneficiarios_no_plano_de_' + 
      format(new Date(filtro.dtaInicio), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dtaFim), 'DD_MM_YYYY') + '.csv';
    }
    // Beneficiários que saíram do Plano
    if (this.state.codTipoConsultaSelected === 3) {
      nomeArquivo = 'beneficiarios_fora_do_plano_de_' + 
      format(new Date(filtro.dtaInicio), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dtaFim), 'DD_MM_YYYY') + '.csv';
    }
    // Beneficiários que completaram aniversário
    if (this.state.codTipoConsultaSelected === 4) {
      nomeArquivo = 'beneficiarios_' + this.state.idade + '_anos_de' +
      format(new Date(filtro.dtaInicio), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dtaFim), 'DD_MM_YYYY') + '.csv';
    }
    await this.consultarBeneficiariosGeral(filtro);
    this.gerarArquivo(nomeArquivo);
  }
  consultarBeneficiariosGeral = async (filtro) => {
    const beneficiarios = await this.relatorioBeneficiariosService.consultarBeneficiariosGeral(filtro);
    this.setState({ beneficiarios: beneficiarios });
  }
  gerarArquivo = (nomeArquivo) => {
    let conteudo = '';
    let jaInseriuCabecalho = false;
    let beneficiarios = this.state.beneficiarios;

    for (var i = 0; i < beneficiarios.length; i++) {
      if (beneficiarios[i].nome.includes('MATRICULA') ||
      beneficiarios[i].nome.includes('TITULARIDADE') ||
      beneficiarios[i].nome.includes('ESTADO_CIVIL')) {
        if (!jaInseriuCabecalho) {
          conteudo = conteudo + beneficiarios[i].nome + '\n';
          jaInseriuCabecalho = true;
        }
      } else {
        conteudo = conteudo + beneficiarios[i].nome + '\n';
      }
    }
    const url = window.URL.createObjectURL(new Blob([conteudo]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);    
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeTipoConsulta = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
    if (event.target.value === 4) {
      this.setState({from: format(subMonths(new Date(), 1), 'YYYY-MM-DD'), to: format(new Date(), 'YYYY-MM-DD')});
    } else {
      this.setState({from: format(subMonths(new Date(), 12), 'YYYY-MM-DD'), to: format(new Date(), 'YYYY-MM-DD')});
    }
  }
  handleClickMarcarDesmarcar = event => {
    this.setState({ checkTodos: !this.state.checkTodos });
    if (!this.state.checkTodos) {
      this.setState({ checkEndereco: true,
        checkTelefone: true,
        checkEmail: true,
        checkMae: true,
        checkSituacao: true,
        checkTutelado: true,
        checkDepEconomico: true,
        checkInvalidez: true, });  
    } else {
      this.setState({ checkEndereco: false,
        checkTelefone: false,
        checkEmail: false,
        checkMae: false,
        checkSituacao: false,
        checkTutelado: false,
        checkDepEconomico: false,
        checkInvalidez: false, });  
    }
  }
  handleChangeCheckBoxEndereco = event => {
    this.setState({ checkEndereco: !this.state.checkEndereco });
  }
  handleChangeCheckBoxTelefone = event => {
    this.setState({ checkTelefone: !this.state.checkTelefone });
  }
  handleChangeCheckBoxEmail = event => {
    this.setState({ checkEmail: !this.state.checkEmail });
  }
  handleChangeCheckBoxMae = event => {
    this.setState({ checkMae: !this.state.checkMae });
  }
  handleChangeCheckBoxSituacao = event => {
    this.setState({ checkSituacao: !this.state.checkSituacao });
  }
  handleChangeCheckBoxTutelado = event => {
    this.setState({ checkTutelado: !this.state.checkTutelado });
  }
  handleChangeCheckBoxDepEconomico = event => {
    this.setState({ checkDepEconomico: !this.state.checkDepEconomico });
  }
  handleChangeCheckBoxInvalidez = event => {
    this.setState({ checkInvalidez: !this.state.checkInvalidez });
  }
  handleChangeCheckBoxDependentes = event => {
    this.setState({ checkDependentes: !this.state.checkDependentes });
  }
  handleChangeCheckBoxPensionista = event => {
    this.setState({ checkPensionista: !this.state.checkPensionista });
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  isBuscarDisabled = () => {
    return (this.state.errorMessageDataInicial !== '' ||
     this.state.from === undefined ||
     this.state.from === 'Invalid Date' ||
     this.state.from === '') ||

     (this.state.errorMessageDataFinal !== '' ||
     this.state.to === undefined ||
     this.state.to === 'Invalid Date' ||
     this.state.to === '') ||
     
     (this.state.codTipoConsultaSelected === 4 &&
      (this.state.idade === null || this.state.idade === undefined));
  }
  handleBlurDataInicial = event => {
    if (this.state.from === null ||
      this.state.from === undefined ||
      this.state.from === '') {
      this.setState({errorMessageDataInicial: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageDataInicial: ''});
    }
  }
  handleBlurDataFinal = event => {
    if (this.state.to === null ||
      this.state.to === undefined ||
      this.state.to === '') {
      this.setState({errorMessageDataFinal: 'Este campo é obrigatório'});
    } else {
      if (isBefore(this.state.to, this.state.from)){
        this.setState({errorMessageDataFinal: 'Data fim menor que data início'});
      } else {
        this.setState({errorMessageDataFinal: ''});
      }
    }
  }
  handleBlurIdade = event => {
    if (this.state.idade === '' || this.state.idade === null || this.state.idade === undefined) {
      this.setState({errorMessageIdade: 'Favor preencher este campo'});
    }
  }
  handleChangeTextFieldIdade = event => {
    var valorNovo = '';
    if (event.target.name === 'idade') {
      valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 2);
      this.setState({ [event.target.name]: valorNovo, errorMessageIdade: '' });
    }
  };
  handleCloseFullScreenPrint = () => {
    this.setState({ fullScreenPrintOpen: false });
  }

  render () {
    const { classes } = this.props;
    const { fetching, codTipoConsultaSelected, checkTodos,
      from, to } = this.state;
    return (
      <React.Fragment>
        <Link to='/relatorio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Relatório de Beneficiários</Typography>
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen /> : null}
        <Paper className={classes.body} elevation={1}>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipoArquivo}>
                Tipo de Consulta
              </InputLabel>
              <Select
                className={classes.selectTipoArquivo}
                value={codTipoConsultaSelected}
                onChange={this.handleChangeTipoConsulta}
                inputProps={{
                  name: 'codTipoConsultaSelected',
                }}
              >
                <MenuItem key={1} value={1}>1 - Consulta Geral</MenuItem>
                <MenuItem key={2} value={2}>2 - Beneficiários que estão no Plano</MenuItem>
                <MenuItem key={3} value={3}>3 - Beneficiários que saíram do Plano</MenuItem>
                <MenuItem key={4} value={4}>4 - Beneficiários que completaram aniversário</MenuItem>
              </Select>
            </FormControl>
            <TextField
              className={classnames(classes.textFieldIdade, {
                [classes.invisible]: this.state.codTipoConsultaSelected !== 4
                })}
              error={this.state.errorMessageIdade !== ''}
              label={this.state.errorMessageIdade !== '' ? this.state.errorMessageIdade : 'Idade'}
              value={this.state.idade === null ? '' : this.state.idade}
              margin='dense'
              id='idade'
              name='idade'
              onBlur={this.handleBlurIdade}
              fullWidth
              onChange={this.handleChangeTextFieldIdade}
            />
            <TextField
              className={classes.textField}
              id='date'
              error={this.state.errorMessageDataInicial !== ''}
              label={this.state.errorMessageDataInicial !== '' ? this.state.errorMessageDataInicial :
              codTipoConsultaSelected === 1 || codTipoConsultaSelected === 2 ? 'Adesão De' : codTipoConsultaSelected === 3 ? 'Saída de' : 'De'}
              type='date'
              value={from}
              onChange={this.handleChange}
              onBlur={this.handleBlurDataInicial}
              inputProps={{
                name: 'from',
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              className={classes.textField}
              id='date'
              error={this.state.errorMessageDataFinal !== ''}
              label={this.state.errorMessageDataFinal !== '' ? this.state.errorMessageDataFinal :
              codTipoConsultaSelected === 1 || codTipoConsultaSelected === 2 ? 'Adesão Até' : codTipoConsultaSelected === 3 ? 'Saída Até' : 'Até'}
              type='date'
              value={to}
              onChange={this.handleChange}
              onBlur={this.handleBlurDataFinal}
              inputProps={{
                name: 'to',
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkDependentes}
                  onChange={this.handleChangeCheckBoxDependentes}
                  name='checkDependentes'
                />
              }
              label='Incluir Dependentes?'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkPensionista}
                  onChange={this.handleChangeCheckBoxPensionista}
                  name='checkPensionista'
                />
              }
              label='Incluir Pensionistas?'
            />
            <Button
              disabled={this.isBuscarDisabled()}
              size='small'
              color='secondary'
              variant='contained'
              title='Exportar para planilha'
              type='submit'
              onClick={this.handleClickBuscar}
              onTouchStart={this.handleClickBuscar}
              className={classes.button}>
              <AspectRatio className={classes.searchIcon} />
              Gerar Arquivo
            </Button>
            <Button
              disabled={this.isBuscarDisabled()}
              size='small'
              variant='contained'
              color='primary'
              title='Visualizar'
              type='submit'
              onClick={this.handleClickVisualizar}
              onTouchStart={this.handleClickVisualizar}
              className={classes.button}>
              <PictureAsPdf />
              Visualizar PDF
            </Button>
          </Paper>
          <Paper className={classes.paperCamposObrigatorios} elevation={1}>
            <Typography className={classes.typographyTituloPaper}>
                Campos Obrigatórios (estes campos sempre estarão presentes nos arquivos)
            </Typography>
            <Typography className={classes.typographyObrigatorios}>
                Carteira, Nome, CPF, Titularidade, Data de Nascimento, Idade, Estado Civil, Sexo, Parentesco, Data Início/Data Fim
            </Typography>
          </Paper>
          <Paper className={classes.paperCamposOpcionais} elevation={1}>
            <Typography className={classes.typographyTituloPaper}>
                Campos Opcionais (estes campos não serão impressos na visualização)
            </Typography>
            <Button
                className={classes.buttonMarcar}
                size='small'
                variant='outlined'
                color='secondary'
                onClick={this.handleClickMarcarDesmarcar}>
                {!checkTodos ? 'Marcar todos' : 'Desmarcar todos'}
              </Button>
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkEndereco}
                  onChange={this.handleChangeCheckBoxEndereco}
                  name='checkEndereco'
                />
              }
              label='Endereço'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkTelefone}
                  onChange={this.handleChangeCheckBoxTelefone}
                  name='checkTelefone'
                />
              }
              label='Telefone'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkEmail}
                  onChange={this.handleChangeCheckBoxEmail}
                  name='checkEmail'
                />
              }
              label='E-mail'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkMae}
                  onChange={this.handleChangeCheckBoxMae}
                  name='checkMae'
                />
              }
              label='Nome Mãe'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkSituacao}
                  onChange={this.handleChangeCheckBoxSituacao}
                  name='checkSituacao'
                />
              }
              label='Situação'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkTutelado}
                  onChange={this.handleChangeCheckBoxTutelado}
                  name='checkTutelado'
                />
              }
              label='Curatelado/Tutelado'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkDepEconomico}
                  onChange={this.handleChangeCheckBoxDepEconomico}
                  name='checkDepEconomico'
                />
              }
              label='Dep. Econômico'
            />
            <FormControlLabel className={classes.checkBox}
              control={
                <Checkbox                  
                  checked={this.state.checkInvalidez}
                  onChange={this.handleChangeCheckBoxInvalidez}
                  name='checkInvalidez'
                />
              }
              label='Possui Invalidez'
            />
          </Paper>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.fullScreenPrintOpen &&
        <FullScreenRelatorioBeneficiarios
          open={this.state.fullScreenPrintOpen}
          handleClose={this.handleCloseFullScreenPrint}
          tituloConsulta={this.state.tituloConsulta}
          filtro={this.state.filtro}
        />}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(RelatorioBeneficiarios);
